import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
import { Button } from './ui/Button';
const includes = ['4 Etapas completas en video', '3 Bonos estratégicos de alto valor', '100 productos digitales validados', 'Acceso inmediato', 'Garantía 7 días sin preguntas'];
export function Pricing() {
  return <section className="py-12 md:py-20 bg-dark-900 relative" data-id="element-194">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold-500/10 via-dark-900 to-dark-900 pointer-events-none" data-id="element-195" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-dark-800 rounded-2xl md:rounded-3xl border-2 border-gold-500 shadow-[0_0_40px_rgba(212,175,55,0.15)] overflow-hidden" data-id="element-197">
          <div className="bg-gold-500 py-3 md:py-4 text-center" data-id="element-198">
            <h2 className="font-display text-black text-base md:text-2xl tracking-widest uppercase px-2" data-id="element-199">
              Motor de Riqueza — Kit Completo
            </h2>
          </div>

          <div className="p-5 md:p-10 text-center" data-id="element-200">
            <div className="flex flex-col items-center justify-center mb-6" data-id="element-201">
              <div className="text-gray-500 line-through text-lg md:text-2xl font-display mb-1" data-id="element-202">
                $157.990
              </div>
              <div className="bg-red-500/10 text-red-400 border border-red-500/20 px-3 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider mb-3" data-id="element-203">
                Ahorrás $108.000
              </div>
              <div className="text-6xl md:text-8xl font-display text-white tracking-tight" data-id="element-204">
                $49.990
              </div>
            </div>

            <div className="bg-dark-900/50 rounded-xl p-4 md:p-6 mb-6 border border-white/5 text-left max-w-md mx-auto" data-id="element-205">
              <ul className="space-y-2.5 md:space-y-3" data-id="element-206">
                {includes.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.05
              }} className="flex items-center gap-3 text-gray-200 font-medium text-sm md:text-base" data-id="element-207">
                    <CheckIcon className="text-gold-500 shrink-0" size={18} data-id="element-208" />
                    {item}
                  </motion.li>)}
              </ul>
            </div>

            <Button className="w-full text-base md:text-xl py-4 md:py-6 px-6 md:px-12 mb-4 shadow-xl" data-id="element-209">
              💥 QUIERO MI NEGOCIO LISTO AHORA
            </Button>

            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-210">
              <span className="flex items-center gap-1" data-id="element-211">
                <LockIcon size={12} className="text-gold-500" data-id="element-212" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-213">
                <ShieldCheckIcon size={12} className="text-gold-500" data-id="element-214" /> Acceso
                en 5 min
              </span>
              <span className="flex items-center gap-1" data-id="element-215">
                <ShieldCheckIcon size={12} className="text-gold-500" data-id="element-216" /> Garantía
                7 días
              </span>
              <span className="text-white" data-id="element-217">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}